export const routesMock = {
  size: 3,
  page: 0,
  hits: 3,
  results: [
    {
      trcid: "c9c0504e-26d0-4a3b-9267-7fcfdb337575",
      creationdate: "2024-05-03T12:09:52.411Z",
      lastupdated: "2024-05-03T12:10:09.705Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "mountainbikeroute-harderwijk-mountainbikeroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/2464115254/mountainbikeroute-ermelo",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "9fa03ff6e4e354a37f4fbfb08194fba45a9ba7f1.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d379313282685aa16d89/9fa03ff6e4e354a37f4fbfb08194fba45a9ba7f1.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p>De mountainbikeroute in Harderwijk is een&nbsp;route van circa 21 kilometer. De MTB route Harderwijk kenmerkt zich door technische singletracks met pittige hoogteverschillen, mooie uitzichten over het Beekhuizerzand, de fraaie Leuvenumse bossen en de Leuvenumse Beek.&nbsp;</p><p>Praktische infromatie</p><p>De route is te starten vanaf de parkeerplaats op de Leuvenumseweg in Harderwijk en is voorzien van houten markeringspaaltjes met het internationale mountainbikelogo.&nbsp;</p><ul><li>Markering:&nbsp;Groene pijl (internationale MTB-teken)</li><li>Afstand:&nbsp;23 kilometer</li><li>Hoogtemeters:&nbsp;165</li><li>Vignetplichtig:&nbsp;Nee</li><li>Verbindingen met andere routes:&nbsp;Ja, in de regio zijn ook de TREK-Trail en de route Ermelo te vinden.&nbsp;</li></ul><p>Kijk voor meer informatie over deze route op:&nbsp;<a href="https://mtbharderwijkermelo.n/" rel="noopener noreferrer" target="_blank" style="color: rgb(108, 186, 61);">mtbharderwijkermelo.nl</a>.&nbsp;</p>',
          shortdescription:
            "De mountainbikeroute in Harderwijk is een route van circa 21 kilometer. De MTB route Harderwijk kenmerkt zich door technische singletracks met pittige hoogteverschillen, mooie uitzichten over het Beekhuizerzand en de fraaie Leuvenumse bossen!",
          title: "Mountainbikeroute Harderwijk [mountainbikeroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Harderwijk",
          citytrcid: null,
          country: "NL",
          housenr: "",
          street: "Boekhorstlaan",
          streettrcid: null,
          zipcode: "3847 LA",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "P Veluwe Harderwijk",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d410313282685aa16d8a",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "9c340821-5331-4f4d-8ff1-449468e65de8",
      creationdate: "2024-05-03T12:05:27.126Z",
      lastupdated: "2024-05-03T12:10:35.108Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "mountainbikeroute-eerbeek-mountainbike-route",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/1729450635/mountainbikeroute-eerbeek",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "9c3611cb-ccd0-4dbd-ac9d-173bea87dea7_1860207199.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d2ef313282685aa16d84/9c3611cb-ccd0-4dbd-ac9d-173bea87dea7_1860207199.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "1dc90850-3008-43c4-b7ef-355b325a5ced_4212592314.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d302313282685aa16d86/1dc90850-3008-43c4-b7ef-355b325a5ced_4212592314.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            "<p>In Eerbeek zijn er twee startlocaties. Bij het station Eerbeek, Stationstraat 2 en bij Bosque aan de Harderwijkerweg.</p><p>Vanuit deze twee locaties is het mogelijk om snel aansluiting te vinden op de Mountainbike route.</p><p>Bij het begin van de route is het mogelijk om lekker warm te draaien op een prachtig parcours. (Rood)</p>",
          shortdescription:
            "Start vanuit Eerbeek om te gaan mountainbiken op de Veluwe en Veluwezoom.",
          title: "Mountainbikeroute Eerbeek [mountainbike route]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Eerbeek",
          citytrcid: null,
          country: "NL",
          housenr: "2",
          street: "Stationstraat ",
          streettrcid: null,
          zipcode: "",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Station Eerbeek",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d307313282685aa16d87",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "fdd19dfb-aa09-40e4-bc94-a378c8a73aa4",
      creationdate: "2024-05-03T12:12:10.387Z",
      lastupdated: "2024-05-03T12:12:27.322Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "rondje-voorthuizen-wandelroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/1344621408/rondje-voorthuizen",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "jdp9150802-3183s_3392131627.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d477313282685aa16d8e/jdp9150802-3183s_3392131627.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p>Rondje Voorthuizen brengt je langs de randen van Voorthuizen en laat je zo de prachtige omgeving van Voorthuizen verkennen!</p><p>Onderweg kom je langs het Wilbrinkbos, waar je heide, vijvers, vennetjes en het landhuis Zandbergen kunt vinden. Het Wilbrinkbos kent door zijn ligging aan een oude Hessenweg een rijke geschiedenis. Hier liep een oude handelsroute van Amersfoort naar Deventer en stamt uit de 13e eeuw. Aan deze weg ontstond landgoed Zandbergen. Huize Zandbergen werd in 1832 eigendom van Willem Wilbrink sr. en bleef tot 1962 eigendom van de familie. Willem Wilbrink sr. en zijn zonen Willem Wilbrink jr. en Gerrit Jan Wilbrink hebben zich erg ingezet voor het behoud van de natuur en het landschap in de omgeving.</p><p>Ook kom je langs de rondweg van Voorthuizen waar in een weiland naast de Overhorsterweg vuurstenen werktuigen en haardresten werden gevonden uit 9000 tot 5000 voor Chr. Daarmee is het de oudste vindplaats van de jagers en verzamelaars in Gelderland.</p><p>Ook wandel je langs recreatiegebied Zeumeren waar van alles te beleven is. Hier vind je aan de Goorderweg bijvoorbeeld het hoogste natuurlijke punt van Voorthuizen!</p><p>Wandelnetwerk Veluwe&nbsp;</p><p>Deze route maakt onderdeel uit van het Wandelnetwerk Veluwe. Met dit wandelnetwerk stippel je gemakkelijk een eigen route uit met behulp van de keuzepunten, ook is het mogelijk om reguliere routes te volgen die ook in het netwerk bewegwijzerd zijn. Meer informatie over de ontwikkeling van het Wandelnetwerk Veluwe? Kijk op&nbsp;<a href="https://www.routebureauveluwe.nl/" rel="noopener noreferrer" target="_blank" style="color: rgb(108, 186, 61);">routebureauveluwe.nl</a>.&nbsp;</p>',
          shortdescription:
            "Ontdek de prachtige omgeving van Voorthuizen! Wandel langs het buitengebied, ontdek het Wilbrink bos en beleef recreatiegebied Zeumeren met deze route van 15 km.",
          title: "Rondje Voorthuizen [wandelroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Voorthuizen",
          citytrcid: null,
          country: "NL",
          housenr: "2",
          street: "Rochetstraat ",
          streettrcid: null,
          zipcode: "3781 CZ ",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Ontmoetingscentrum De Eng (B77)",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d49a313282685aa16d8f",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "665f8192-c229-4657-b86c-5fa250c35d83",
      creationdate: "2024-05-03T12:14:40.091Z",
      lastupdated: "2024-05-03T12:14:40.091Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "rondje-kootwijkerbroek-wandelroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "jdp9150802-2968s-1_2147485029.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d52b313282685aa16d92/jdp9150802-2968s-1_2147485029.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p>Rondje Kootwijkerbroek brengt je langs de randen van Kootwijkerbroek. Geniet van het uitgestrekte landschap en ervaar de rust in deze prachtige omgeving.</p><p>In de verte spot je de Puurveense Molen. Dit was eeuwenlang het beeldbepalende gebouw van Kootwijkerbroek. Nadat deze molen in 1964 is afgebrand en het gemis van een molen het dorp bezighield, heeft de Stichting \'De Puurveense Molen\' zich ingezet om de molen te herbouwen. Dat is gelukt en in 2016 is de \'nieuwe\' Puurveense Molen geopend. Hier koop je nu verschillende bakproducten en kun je een praatje met de Molenaar maken.</p><p>Wandelnetwerk Veluwe&nbsp;</p><p>Deze route maakt onderdeel uit van het Wandelnetwerk Veluwe. Met dit wandelnetwerk stippel je gemakkelijk een eigen route uit met behulp van de keuzepunten, ook is het mogelijk om reguliere routes te volgen die ook in het netwerk bewegwijzerd zijn. Meer informatie over de ontwikkeling van het Wandelnetwerk Veluwe? Kijk op&nbsp;<a href="https://www.routebureauveluwe.nl/" rel="noopener noreferrer" target="_blank" style="color: rgb(108, 186, 61);">routebureauveluwe.nl</a>.&nbsp;</p>',
          shortdescription:
            "Ontdek het uitgestrekte landschap van Kootwijkerbroek met de wandelroute van 8,8 km en spot onderweg de Puurveense molen!",
          title: "Rondje Kootwijkerbroek [wandelroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Kootwijkerbroek",
          citytrcid: null,
          country: "NL",
          housenr: "69 ",
          street: "Essenerweg ",
          streettrcid: null,
          zipcode: "3774 CB",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Kootwijkerbroek, keuzepunt B47",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d530313282685aa16d93",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "316b4172-d27f-4c79-a638-04b364ad4c6a",
      creationdate: "2024-05-03T12:18:17.778Z",
      lastupdated: "2024-05-03T12:18:24.451Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "fiets-expeditie-ermelo-fietsroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/3237763770/fiets-expeditie-ermelo",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "fietsexpeditie-lancering-004_1567338475.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d605313282685aa16d95/fietsexpeditie-lancering-004_1567338475.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p><span style="color: rgb(0, 0, 0);">Expeditieleden kunnen op verschillende hotspots een QR-code scannen op de interactieve missiekaart en luisteren naar een storyteller. Hij vertelt iets over de plek waar de speurneuzen zich dan bevinden en je ontvangt een opdracht. Kinderen en ouders leren zo meer over de Romeinen en de geschiedenis van Oud-Groevenbeek en verdienen daarbij Romeinse munten.</span></p>',
          shortdescription:
            "Gezinnen en kinderen gaan in deze fietsexpeditie met de speciale missiekaart op pad en leren de omgeving van Ermelo beter kennen. De missiekaart is gratis te verkrijgen bij VVV Ermelo.",
          title: "Fiets Expeditie Ermelo [fietsroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Ermelo",
          citytrcid: null,
          country: "NL",
          housenr: "20",
          street: "Stationsstraat",
          streettrcid: null,
          zipcode: "3851 NH",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d609313282685aa16d96",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "5947b9fb-d09b-4148-8edb-f0f49cfdf194",
      creationdate: "2024-05-03T12:22:43.219Z",
      lastupdated: "2024-05-03T12:22:43.219Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "fietsroute-posbank-start-eerbeek-fietsroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/1618515602/fietsroute-posbank-start-eerbeek",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "a984119e-bb60-4116-b4ff-2bfd67b9c8a2_3457171081.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d643313282685aa16d99/a984119e-bb60-4116-b4ff-2bfd67b9c8a2_3457171081.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p>Start vanuit Eerbeek je fietsroute over de Posbank. Heb je sterke benen of een E-Bike? Dan moet je deze route absoluut proberen. Je komt uit op de top van de Posbank met onderweg gelegenheid om heerlijk te genieten van de prachtige omgeving.</p><p>Ook Eerbeek is de moeite waard om een hapje en een drankje te doen.</p><p>Heb je geen E Bike. Huur deze bij&nbsp;<a href="https://www.veluweactief-eerbeek.nl/" rel="noopener noreferrer" target="_blank" style="color: rgb(108, 186, 61);">Veluwe Actief Eerbeek</a></p>',
          shortdescription:
            "Een fietsroute waarbij je de Posbank op de Veluwe gaat ontdekken.",
          title: "Fietsroute Posbank start Eerbeek [fietsroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Eerbeek",
          citytrcid: null,
          country: "NL",
          housenr: "",
          street: "Stuijvenburchstraat",
          streettrcid: null,
          zipcode: "",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Knooppunt 63 Eerbeek",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d713313282685aa16d9a",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "d1366c72-cd92-45c3-9ae0-818143966ec4",
      creationdate: "2024-05-03T12:26:42.009Z",
      lastupdated: "2024-05-03T12:26:42.009Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "rondje-edese-bos-ruitersroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/4140574901/rondje-edese-bos",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "rondje-edese-bos-bezoek-ede_3288149912.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d75e313282685aa16d9c/rondje-edese-bos-bezoek-ede_3288149912.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          lang: "nl",
          longdescription:
            '<p>Verken het afwisselende natuurgebied boven Ede met het Rondje Edese Bos. Naast bos trek je tijdens deze route ook een stukje over de Ginkelse Heide.</p><p>Slingeren door het bos</p><p>Het terrein van het Edese Bos bestaat uit afwisselend bosgebied. Terwijl je over de slingerende paden stapt, geniet je van zowel naaldbomen als loofbomen. Ondanks de soms bochtige paadjes is deze route geschikt voor zowel ruiters als menners.</p><p>Breid de route uit</p><p>Toe aan een langere rit? Deze route is goed uit te breiden of te combineren met andere routes in dit gebied. Maak deze route bijvoorbeeld langer met (een deel van) de&nbsp;<a href="https://www.bezoek-ede.nl/natuur-actief/routes/2081904749/dagtocht-ginkelse-heide" rel="noopener noreferrer" target="_blank" style="color: rgb(108, 186, 61);">dagtocht Ginkelse Heide</a>.</p>',
          shortdescription:
            "Het Rondje Edese Bos is een afwisselende route. Onderweg trek je door bos en een kort stuk over de Ginkelse Heide. Dit rondje is geschikt voor ruiters en menners.",
          title: "Rondje Edese Bos [Ruitersroute]",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Ede",
          citytrcid: null,
          country: "NL",
          housenr: "",
          street: "Apeldoornseweg",
          streettrcid: null,
          zipcode: "6718",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Edese Bos",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d802313282685aa16d9d",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
    },
    {
      trcid: "2ef88199-581f-4b1b-a3e2-81a6e8704d08",
      creationdate: "2024-05-03T12:28:31.397Z",
      lastupdated: "2024-05-03T12:28:49.895Z",
      createdby: "kick@eventconnectors.nl",
      lastupdatedby: "kick@eventconnectors.nl",
      slug: "de-veluwe-te-paard-ruitersroute",
      wfstatus: "readyforvalidation",
      published: false,
      deleted: true,
      offline: true,
      entitytype: "ROUTE",
      contactinfo: {
        label: null,
        mails: [],
        phones: [],
        faxes: [],
        urls: [
          {
            url: "https://www.visitveluwe.nl/routes-op-de-veluwe/routes/2015502482/de-veluwe-te-paard",
            descriptioncode: null,
            targetLanguage: "nl",
            reservations: null,
            urlServiceType: "general",
            descriptionTranslations: [],
          },
        ],
        addresses: [],
        mail: null,
        phone: null,
        fax: null,
        address: null,
      },
      trcItemCategories: {
        types: [],
        categories: [],
        soldout: null,
        canceled: null,
      },
      performers: [],
      files: [
        {
          trcid: null,
          main: null,
          copyright: null,
          filename: "ff5f8f95fee00d2877dd502ffca7d4aa4c0313b8.webp",
          hlink:
            "https://staging-app.thefeedfactory.nl/api/assets/6634d86d313282685aa16d9f/ff5f8f95fee00d2877dd502ffca7d4aa4c0313b8.webp",
          filetype: "webp",
          mediatype: "photo",
          targetLanguage: null,
          title: {
            label: "",
            titleTranslations: [
              {
                lang: "nl",
                label: "",
              },
            ],
          },
        },
      ],
      trcItemDetails: [
        {
          longdescription:
            "<p>Paarse heidevelden, eeuwenoude bossen, uitgestrekte weilanden en witte zandverstuivingen: dat is de Veluwe! Al dit moois kom je tegen op deze ruiterroute die volledig is gemarkeerd met knooppunten en over brede zandpaden loopt. De route is 24 kilometer lang en geschikt voor zowel menners als ruiters.</p><p>De route begint in het Veluwse dorpje Stoe , vanaf parkeerplaats P Veluwe, 3776 LZ Houtbeekweg . Vanaf de snelweg A1 bij afslag Garderen , Stroe volgen, via de rotonde en direct na de spoorlijn links de Houtbeekweg volgen naar de parkeerplaats. Er zijn aanbindhekken.</p><p>De Houtbeekweg langs het spoor leidt naar het hek waar je echt de Veluwe binnentreedt. Volg dit pad tot aan het eerste knooppunt 23. Volg de routenummers&nbsp;start&nbsp;-&nbsp;23 - 24 - 25 - 30 - 27 - 26 - 18 - 19 - 10 - 11 -04 - 05 - 06 - 07 - 08 - 09 - 21 - 22 - 23&nbsp;om weer terug te komen op de parkeerplaats.</p><p>Tussen de knooppunten 10 en 11 is een rustplaats met aanbindhekken en een picknickbank. Een heerlijke plek om even te pauzeren en te genieten van de stilte in het bos.</p><p>Bijzonderheden:&nbsp;brede zandpaden, geen horeca onderweg, wel rustplaats</p>",
          shortdescription:
            "Paarse heidevelden, eeuwenoude bossen, uitgestrekte weilanden en witte zandverstuivingen: dat is de Veluwe! Al dit moois kom je tegen op deze ruiterroute die volledig is gemarkeerd met knooppunten en over brede zandpaden loopt.",
          title: "De Veluwe te Paard [Ruitersroute]",
          lang: "nl",
        },
      ],
      trcitemRelation: {
        subItemGroups: [],
      },
      location: {
        address: {
          main: null,
          reservation: null,
          title: null,
          city: "Stroe",
          citytrcid: null,
          country: "NL",
          housenr: "",
          street: "Houtbeekweg",
          streettrcid: null,
          zipcode: "3776 LZ",
          province: null,
          neighbourhood: "",
          district: "",
          gisCoordinates: [],
        },
        label: "Veluwe",
        locationItem: null,
      },
      translations: {
        primaryLanguage: "nl",
        availableLanguages: ["nl"],
      },
      id: "6634d86f313282685aa16da0",
      acl: {
        readers: [],
        editors: [],
        managers: [],
      },
      availablefrom: null,
      availableto: null,
    },
  ],
};
